import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import authErrorImg from '../../common/assets/authentication-error.svg';
import { ErrorDisplay } from '../../common/ui/error-display';
import { loginViaRedirectUrl } from '../../common/utils';
import { messages } from './messages';

type Props = {
	loginRedirectUrl?: string;
};

export const AuthenticationErrorView = ({ loginRedirectUrl }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<ErrorDisplay
			header={formatMessage(messages.authErrorHeader)}
			image={<Image src={authErrorImg} alt="" />}
		>
			{loginRedirectUrl && (
				<Button
					appearance="primary"
					onClick={() => loginViaRedirectUrl(loginRedirectUrl)}
					interactionName="auto-generated.jira-issue-view-errors.ui.authentication-error-view.button"
				>
					{formatMessage(messages.authButton)}
				</Button>
			)}
		</ErrorDisplay>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Image = styled.img({
	width: '160px',
	marginBottom: token('space.200', '16px'),
});
